if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.tabsElement = this.querySelector('[data-tabs]');

      // Nav
      this.tabsNav = this.querySelector('[data-tabs-nav]');
      this.tabsLinks = this.querySelectorAll('[data-tabs-link]');

      // Content
      this.tabsContent = this.querySelector('[data-tabs-content]');
      this.tabsLinksMobile = this.tabsContent.querySelector('[data-tabs-link]');
      this.tabsPanes = this.tabsContent.querySelectorAll('[data-tabs-content-pane');
      this.readMoreToggleArr = this.querySelectorAll('[data-toggle-read-more]');

      this.jdgmPreviewBadge = document.querySelector('.jdgm-preview-badge');

      this.init();

      if (this.readMoreToggleArr.length > 0) {
        this.readMoreToggleArr.forEach(toggle => {
          toggle.addEventListener('click', () => {
          toggle.offsetParent.classList.toggle('is-expanded');
          })
        });
      }

      window.addEventListener('resize', () => {
        const ActiveTabsLinks = this.querySelectorAll('.product-tabs__nav-item.is-active');
        if (window.innerWidth >= 768) {
          if (ActiveTabsLinks?.length < 1) this.init();
        }
      })

      this.tabsLinks.forEach(link => link.addEventListener('click', (event) => {
        if (!link.classList.contains('is-active')) {
          this.handleTabClick(event);
        } else {
          const { tabsLink } = link.dataset
          const pane = this.tabsContent.querySelector(`[data-tabs-content-pane="${tabsLink}"`);
          link.classList.remove('is-active');
          pane.classList.remove('is-active');
        }
      }))

      this.jdgmPreviewBadge.addEventListener('click', () => this.scrollToReview())
    }



    init() {
      // Activate first available tab if the're is not active
      this.tabsLinks.forEach(link => {
        if (!link.classList.contains('is-active')) {
          const firstLink = this.tabsLinks[0];
          const { tabsLink } = firstLink.dataset
          const firstTabsNavLink = this.tabsNav.querySelector(`[data-tabs-link="${tabsLink}"`);
          const firstTabsLink = this.tabsContent.querySelector(`[data-tabs-link="${tabsLink}"`);
          const firstTabsPane = this.tabsContent.querySelector(`[data-tabs-content-pane="${tabsLink}"`);

          firstTabsNavLink.classList.add('is-active');
          firstTabsLink.classList.add('is-active');
          firstTabsPane.classList.add('is-active');

          //Handle read more button
          const tabHeight = firstTabsPane.offsetHeight;
          if (tabHeight > 740) {
            firstTabsPane.classList.add('product-tabs__content-pane--read-more');
          }
        }
      });
    }

    handleTabClick(event) {
      // Hide all tab panes
      this.tabsPanes.forEach(pane => {
        pane.classList.remove('is-active')
      });

      // Deactivate all links
      this.tabsLinks.forEach(link => {
        link.classList.remove('is-active')
      });

      // Mark the clicked link as active
      event.currentTarget.classList.add('is-active');

      // Find the associated pane and show it
      const { tabsLink } = event.currentTarget.dataset
      const tabsContentLink = this.tabsContent.querySelector(`[data-tabs-link="${tabsLink}"`);
      const tabsPane = this.tabsContent.querySelector(`[data-tabs-content-pane="${tabsLink}"`);
      tabsContentLink.classList.add('is-active');
      tabsPane.classList.add('is-active');

      //Handle read more button
      const tabHeight = tabsPane.offsetHeight;
      if (tabHeight > 740) {
        tabsPane.classList.add('product-tabs__content-pane--read-more');
      }
    }

    scrollToReview() {
      location.hash = "judgeme_product_reviews"
      window.location.hash;
      jdgmSettings.revTabSelector = 'product-tabs .product-tabs__nav-list .product-tabs__nav-item:last-child';
    }
  }

  customElements.define('product-tabs', ProductTabs);
}
